import React, { useEffect, useState } from 'react';
import { StatisticsBlock } from './StatisticsBlock';
import { StatisticsTab } from './StatisticsTab';
import { DocumentsBlock } from './DocumentsBlock';
import { homeService } from '../../services/homeService';
import { DispatcherHomeStatisticsDto } from '../../models/home/dispatcherHomeStatisticsDto';
import { ROUTES } from '../../constants/routes';
import { useNavigate } from 'react-router-dom';
import TmNotebook from '../../icons/TmNotebook';
import TmBuilding from '../../icons/TmBuilding';
import TmPerson from '../../icons/TmPerson';
import TmMonitor from '../../icons/TmMonitor';
import TmHeart from '../../icons/TmHeart';
import TmCheckmark from '../../icons/TmCheckmark';
import TmX from '../../icons/TmX';
import { Box } from '@mui/material';
import ErrorAlert from '../common/ErrorAlert';

export const DispatcherHome: React.FC = () => {
    const navigate = useNavigate();
    const [statistics, setStatistics] = useState<DispatcherHomeStatisticsDto | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        loadStatistics();
    }, []);

    const loadStatistics = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await homeService.getDispatcherStatistics();
            setStatistics(response.data.data);
        } catch (e: any) {
            setError(e.message ?? 'Ошибка загрузки статистики');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box>
            {error && <ErrorAlert message={error} onClose={() => setError(null)} />}

            <StatisticsBlock title="Общая статистика">
                <StatisticsTab
                    icon={<TmNotebook />}
                    label="Осмотры в этом месяце"
                    value={statistics?.generalStatistics.medicalcheckupsCount ?? null}
                    loading={loading}
                    onClick={() => navigate(ROUTES.medicalCheckups.history)}
                />
                <StatisticsTab
                    icon={<TmBuilding />}
                    label="Компании"
                    value={statistics?.generalStatistics.companiesCount ?? null}
                    loading={loading}
                    onClick={() => navigate(ROUTES.clients.list)}
                />
                <StatisticsTab
                    icon={<TmPerson />}
                    label="Сотрудники"
                    value={statistics?.generalStatistics.employeesCount ?? null}
                    loading={loading}
                    onClick={() => navigate(ROUTES.drivers.list)}
                />
                <StatisticsTab
                    icon={<TmMonitor />}
                    label="Терминалы"
                    value={statistics?.generalStatistics.terminalsCount ?? null}
                    loading={loading}
                    onClick={() => navigate(ROUTES.terminals.list)}
                />
            </StatisticsBlock>

            <StatisticsBlock title="Осмотры сегодня">
                <StatisticsTab
                    icon={<TmHeart />}
                    label="Всего"
                    value={statistics?.todayInspections.totalCount ?? null}
                    loading={loading}
                    onClick={() => navigate(ROUTES.medicalCheckups.history)}
                />
                <StatisticsTab
                    icon={<TmCheckmark />}
                    label="Допущено"
                    value={statistics?.todayInspections.approvedCount ?? null}
                    loading={loading}
                    onClick={() => navigate(ROUTES.medicalCheckups.history)}
                />
                <StatisticsTab
                    icon={<TmX />}
                    label="Не допущено"
                    value={statistics?.todayInspections.rejectedCount ?? null}
                    loading={loading}
                    onClick={() => navigate(ROUTES.medicalCheckups.history)}
                />
            </StatisticsBlock>

            <DocumentsBlock />
        </Box>
    );
};

